import { Component, Vue, Prop } from 'vue-property-decorator';
import Parallax from 'vue-parallaxy';
import DottedLine from '@/assets/icons/dotted-line-2.svg?inline';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';
import { ImageWidths, ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import { TextScrollBlockViewModel } from './TextScrollModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import { getResizeImage } from '@/utils/commonUtils';

const TextScrollModuleProps = Vue.extend({
  props: getComponentProps<TextScrollBlockViewModel>({
    ShowMobileImages: true,
    LargeTitle: 'FAQS',
    Title: 'FAQs and key information',
    Text:
      'From the best time to go, to packing the right footwear, we answer enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
    Cta: { Link: 'about', Title: 'read more' },
    Image1: {
      Url: getResizeImage('stingray.jpg'),
      Alt: 'Stinray',
    },
    Image2: { Url: getResizeImage('scuba-diver.jpg'), Alt: 'Diver' },
    Image3: { Url: getResizeImage('fish-tank.jpg'), Alt: 'Diver' },
    ImageCutout: {
      Url: getResizeImage('diver.png'),
      Alt: 'Diver',
    },
    AlternateImageLayout: false,
  }),
});

@Component({
  components: {
    Parallax,
    DottedLine,
    ResponsiveImage,
    ResponsiveImageRatio,
  },
})
export default class TextScrollModule extends TextScrollModuleProps {
  animate = false;
  intersectionOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: [0.75, 1],
  }; // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

  imageSizes: ImageSizes = {
    def: new ImageSize([240, 360]),
    sizes: {
      md: new ImageSize([260, 390]),
      xl: new ImageSize([360, 540]),
    },
  };

  imageWidths: ImageWidths = {
    def: 463,
    sizes: {
      sm: 636,
      md: 992,
      lg: 793,
      xl: 993,
    },
  };

  parallaxImageSizes: ImageSizes = {
    def: new ImageSize([338, 507]),
    sizes: {
      md: new ImageSize([350, 525]),
      xl: new ImageSize([456, 682]),
    },
  };

  get titleLength() {
    return this.p.LargeTitle.length > 7;
  }

  // Methods
  onWaypoint(el: any) {
    this.animate = el.direction === 'top';
  }
}
